<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
		<g id="Ellipse_187" data-name="Ellipse 187" fill="#eff2f9" stroke="#d6ddea" stroke-width="1">
			<circle cx="10" cy="10" r="10" stroke="none" />
			<circle cx="10" cy="10" r="9.5" fill="none" />
		</g>
	</svg>
</template>

<script>
export default {
	name: 'WaitingSVG',
};
</script>
